import Vue from 'vue'
import axios, { AxiosResponse, AxiosError } from 'axios'
import VueAxios from 'vue-axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

axiosInstance.interceptors.response.use((response: AxiosResponse) => {
  return response
}, (error: AxiosError) => {
  if (error.response && error.response.status === 401) {
    location.href = '/auth/login?returnUrl=' + location.href
  } else if (error.response && error.response.status === 403) {
    // TODO
  }

  Promise.reject(error)
})

Vue.use(VueAxios, axiosInstance)
